import { AppModal } from '@/components/compose/app.modal';
import { ListRenderItem } from 'react-native';
import {
  DataQueryPaginateDto,
  MongoQueryTypesEnum,
  numbersToPersian,
  smartDate,
  Transaction,
  TransactionTypeEnum,
  translateTransactionMode,
  translateTransactionType,
  UserTypeEnum,
} from '@matap/shared';
import { InfiniteLoaderList } from '@/components/compose/infinite.loader.list';
import { AppListRow } from '@/components/compose/app.list.row';
import { Box } from '@/components/base/box';
import { AppTextView } from '@/components/base/app.text.view';
import React from 'react';
import styled from 'styled-components/native';
import { useUser } from '@/hooks/use.user';
import { AppImageView } from '@/components/base/app.image.view';
import { useAssets } from '@/hooks/use.assets';
import { useQueryTransactions } from '@/apis/transactions';
import { hpVal, numberWithCommas } from '../../utils';

export default function TransactionsHistoryModal() {
  const api = useQueryTransactions<DataQueryPaginateDto<Transaction>>({ query: { type: MongoQueryTypesEnum.PAGINATE } });

  return (
    <AppModal title={'تاریخچه تراکنش ها'}>
      <InfiniteLoaderList api={api as any} render={renderTransaction} />
    </AppModal>
  );
}

const renderTransaction: ListRenderItem<Transaction> = ({ item }) => <TransactionItem item={item} />;

const TransactionItem = React.memo(function TransactionItem({ item }: { item: Transaction }) {
  const { userType } = useUser();
  const assets = useAssets();
  return (
    <TransactionContainer>
      <TransactionRow
        leftIcon={false}
        title={parseTransactionType(item.type, userType, item.issuer)}
        subtitle={`${numbersToPersian(numberWithCommas(item.amount))} تومان`}
        renderImage={() => {
          const mode = translateTransactionMode(item.type, userType);
          return <Image source={mode === 'deposit' ? assets.images.deposit : mode === 'settlement' ? assets.images.settlement : assets.images.withdrawal} />;
        }}
      >
        <DateRow fullWidth>
          <AppTextView text={smartDate(item.createdAt).formatJalali()} textColor={'black_light'} variant={'medium'} />
          <AppTextView text={`${translateTransactionType(item.type)}`} textColor={'black_light'} variant={'medium'} />
        </DateRow>
      </TransactionRow>
    </TransactionContainer>
  );
});

const TransactionContainer = styled(Box)`
  flex-direction: column;
`;

const Image = styled(AppImageView)`
  width: ${hpVal(7)};
  height: ${hpVal(7)};
`;

const DateRow = styled(Box)`
  background-color: ${({ theme }) => theme.colors.greyWhite};
  padding: 5px;
  padding-left: 15px;
  padding-right: 15px;
  border-bottom-right-radius: ${hpVal(1.2)};
  border-bottom-left-radius: ${hpVal(1.2)};
  flex-direction: row;
  justify-content: space-between;
`;

const TransactionRow = styled(AppListRow)`
  min-height: 150px;
`;

function parseTransactionType(type: TransactionTypeEnum, userType: UserTypeEnum, issuer: Transaction['issuer']) {
  const mode = translateTransactionMode(type, userType);
  if (mode === 'deposit') {
    const by = !issuer ? '' : issuer.type === 'admin' ? 'ادمین' : issuer.name;
    return `واریز توسط ${by}`;
  }
  if (mode === 'settlement') {
    return 'تسویه حساب';
  }
  return `برداشت`;
}
